import {prop} from 'ramda'

import {Brand} from '../../../brand/types'
import {getCheckoutHost} from '../../../brand/utils'
import {COGNITO_ROUTES} from '../../constants'
import {AuthenticationFlows, SourceComponentType} from '../../types/Auth'

export const APP_EMAIL_SIGN_IN_PATH = '/sign-in/email'

/**
 * Where the email button sends the Flutter WebView. The app intercepts this
 * navigation and signs the user in natively.
 */
export const getAppEmailSignInUrl = ({
  brand,
  appEnv,
  sourceComponent,
  flow,
  returnUrl
}: {
  brand: Brand
  appEnv?: string
  sourceComponent: SourceComponentType
  flow: AuthenticationFlows | null
  returnUrl: string
}) => {
  const cleanReturnUrl = new URL(returnUrl)
  cleanReturnUrl.searchParams.delete('showSusi')

  const url = new URL(APP_EMAIL_SIGN_IN_PATH, getCheckoutHost({brand, appEnv}))
  url.searchParams.set('returnUrl', cleanReturnUrl.toString())
  url.searchParams.set('sourceComponent', sourceComponent)
  if (flow) url.searchParams.set('flow', flow)

  return url.toString()
}

export const getUrlPathName = (url?: string) => {
  if (!url) return
  const lastSearchUrl = new URL(url)

  return prop('pathname')(lastSearchUrl)
}

export const isCognitoRoute = (pathname: string) =>
  COGNITO_ROUTES.includes(pathname)
